import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

document.addEventListener("DOMContentLoaded", () => {
  // If window width is less than 780px disable parallax
  if (window.innerWidth < 780) {
    return;
  }

  const parallaxWrappers = document.querySelectorAll(
    ".parallax-wrapper__content"
  );

  parallaxWrappers.forEach((wrapper) => {
    const textImageBlocks = wrapper.querySelectorAll(
      ".mg-block--text-image--variant-parallax"
    );
    if (textImageBlocks.length <= 1) return; // Skip if only one block

    let blockHeight;
    const animation = gsap.timeline();

    function initBlocks() {
      // Clear any existing animations
      animation.clear();

      // Get the height of the first block
      blockHeight = textImageBlocks[0].offsetHeight;

      // Set initial positions and create animations
      textImageBlocks.forEach((block, index) => {
        // Add entrance animations for elements within each block
        const media = block.querySelector(".media");
        const eyebrow = block.querySelector(".text-image__eyebrow");
        const title = block.querySelector(".text-image__title");
        const subtitle = block.querySelector(".text-image__subtitle");
        const cta = block.querySelector(".text-image__cta");

        // Create a timeline for this block's elements
        const blockAnimation = gsap.timeline({
          scrollTrigger: {
            trigger: block,
            start: "top 80%",
            end: "top 20%",
            toggleActions: "play none none none",
          },
        });

        // Set initial states
        gsap.set([media, eyebrow, title, subtitle, cta], {
          opacity: 0,
          y: 30,
        });

        // Set initial scale for media zoom effect
        if (media) {
          gsap.set(media, {
            scale: 1.1,
          });
        }

        // Media animation
        if (media) {
          blockAnimation.to(
            media,
            {
              opacity: 1,
              scale: 1,
              duration: 1,
              ease: "power2.out",
              y: 0,
            },
            0
          );
        }

        // Text elements animations
        if (eyebrow) {
          blockAnimation.to(
            eyebrow,
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: "power2.out",
            },
            0.4
          );
        }

        if (title) {
          blockAnimation.to(
            title,
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: "power2.out",
            },
            0.6
          );
        }

        if (subtitle) {
          blockAnimation.to(
            subtitle,
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: "power2.out",
            },
            0.8
          );
        }

        if (cta) {
          blockAnimation.to(
            cta,
            {
              opacity: 1,
              y: 0,
              duration: 0.8,
              ease: "power2.out",
            },
            1
          );
        }

        // Stacking animation (for blocks after the first one)
        if (index > 0) {
          // Set initial position further down and add extra spacing between blocks
          gsap.set(block, {
            y: index * blockHeight + index * 200, // Add 50px extra spacing between blocks
          });

          // Animate to final position with sequential timing
          animation.to(
            block,
            {
              y: 0,
              duration: index * 0.5,
              ease: "power3.inOut",
            },
            index * 0.2 // Delay each block's animation start
          );
        }
      });
    }

    // Initialize blocks
    initBlocks();

    // Create the scroll trigger for stacking effect
    ScrollTrigger.create({
      trigger: wrapper,
      start: "top top",
      pin: true,
      end: () => `+=${(textImageBlocks.length + 0.5) * blockHeight}`, // Add extra space at the end
      scrub: true,
      animation,
      invalidateOnRefresh: true,
      onUpdate: (self) => {
        // Add padding to the wrapper based on scroll progress
        const progress = self.progress;
        if (progress === 1) {
          // When animation is complete, add padding to prevent overlap
          wrapper.style.paddingBottom = `${blockHeight}px`;
        } else {
          wrapper.style.paddingBottom = "0px";
        }
      },
    });

    // Add a spacer element after the wrapper
    const spacer = document.createElement("div");
    spacer.style.height = `${blockHeight}px`;
    wrapper.parentNode.insertBefore(spacer, wrapper.nextSibling);

    // Clean up spacer on refresh
    ScrollTrigger.addEventListener("refreshInit", () => {
      spacer && spacer.parentNode && spacer.parentNode.removeChild(spacer);
    });
  });
});
